import ServicePlanItemDetails from 'components/service-plan-item-details';

export default function ServicePlanDetails() {
  return (
    <ServicePlanItemDetails />
  );
}
